/**
 * Provides JS functionality for tracking alert display.
 */
export class LocationGrid extends DrupalBehavior {
  onContent(context) {
    function initGrid(context) {
      $('.location-grid--group .location-grid--group--title', context).each(
        function (index) {
          $(this).attr('data-location-grid-group', index);
        }
      );

      $('.location-grid--group', context).each(function (index) {
        $(this).attr('data-location-grid-group-id', index);
      });

      resetGrid();
    }

    function resetGrid() {
      $(
        '.location-grid--nav--item, .location-grid--group, .location-grid--group--title',
        context
      ).removeClass('active');
      const gridCount = $('.location-grid--group', context).length;
      if (gridCount === 1) {
        $('.location-grid--group', context).addClass('active');
        $('.location-grid--instructions', context).remove();
      } else {
        $('.location-grid--nav--item', context).first().addClass('active');
        $('.location-grid--group', context).first().addClass('active');
      }
    }

    function gridBehavior(mql) {
      if (mql.matches) {
        //Mobile view
        resetGrid();

        //Reset event handlers
        $('.location-grid--group--title button', context).off();

        //Hide inactive grids
        gsap.to($('.location-grid--group--items'), {
          duration: 0.25,
          height: 0,
          ease: 'power4.out',
        });

        //Expand default grid
        const $locationGroup = $('.location-grid--group.active');
        const $locationGroupItems = $locationGroup.find(
          '.location-grid--group--items'
        );

        // activate the title also
        const $locationGroupTitle = $locationGroup.find(
          '.location-grid--group--title'
        );
        $locationGroupTitle.addClass('active');

        gsap.to($locationGroupItems, {
          duration: 0.25,
          height: 'auto',
          ease: 'power4.out',
        });

        //Event handler for accordions
        $('.location-grid--group--title button', context).on(
          'click',
          function (e) {
            e.preventDefault();
            const $locationGroupTitle = $(this).parent();
            $locationGroupTitle.toggleClass('active');
            const $locationGroup = $(
              '[data-location-grid-group-id="' +
                $locationGroupTitle.attr('data-location-grid-group') +
                '"]'
            ).toggleClass('active');
            const $locationGroupItems = $locationGroup.find(
              '.location-grid--group--items'
            );
            if ($locationGroup.hasClass('active')) {
              gsap.to($locationGroupItems, {
                duration: 0.25,
                height: 'auto',
                ease: 'power4.out',
              });
            } else {
              gsap.to($locationGroupItems, {
                duration: 0.25,
                height: 0,
                ease: 'power4.out',
              });
            }
          }
        );
      } else {
        //Desktop view
        resetGrid();

        //Reset event handlers
        $('.location-grid--nav--item button', context).off();

        //Reset grid heights
        const $locationGroupItems = $('.location-grid--group--items');
        gsap.to($locationGroupItems, {
          duration: 0.25,
          height: 'auto',
          ease: 'power4.out',
        });

        //Event handler
        $('.location-grid--nav--item button', context).on(
          'click',
          function (e) {
            e.preventDefault();
            if (!$(this).parent().hasClass('active')) {
              $(
                '.location-grid--nav--item, .location-grid--group',
                context
              ).removeClass('active');
              const $locationGroupTitle = $(this).parent();
              $locationGroupTitle.addClass('active');
              const $locationGroup = $(
                '[data-location-grid-group-id="' +
                  $locationGroupTitle.attr('data-location-grid-group') +
                  '"]'
              );
              $locationGroup.addClass('active');
            }
          }
        );
      }
    }

    const locationGrid = context.querySelector('.location-grid--group');
    if (locationGrid) {
      initGrid(context);
      let mql = window.matchMedia('(max-width: 991px)');
      mql.addEventListener('change', gridBehavior);
      gridBehavior(mql);
    }
  }
}

DrupalBehavior.register('rush_theme.components', 'location_grid', LocationGrid);
